export default __webpack_public_path__ + "static/media/business website.a612488b.svg";